import React from 'react';
import Tool, { type ToolArgs } from '../../../tools/Tool';
import { normalizeHref, displayURL } from '../utils';
import { isLinkElement } from '../../../types/guards';
import type { Placement } from '@floating-ui/dom';

// Open hyperlink.
class ToolOpenLink extends Tool {
  static toolName = 'Open link';
  static iconClass = 'fa-regular fa-arrow-up-right-from-square';

  static renderToolbarButtonIcon({ element }: ToolArgs): JSX.Element {
    let displayUrl = '';
    if (
      element &&
      isLinkElement(element) &&
      element.link_href &&
      element.link_href.length > 4
    ) {
      // Simplify the URL a little for display
      displayUrl = displayURL(element.link_href);
    }
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--spacer-1)',
        }}
      >
        {displayUrl && (
          <span
            style={{
              maxWidth: 200,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {displayUrl}
          </span>
        )}
        <i className="fa-regular fa-arrow-up-right-from-square" />
      </div>
    );
  }

  static action({ element }: ToolArgs): void {
    if (!element || !isLinkElement(element)) return;

    if (element.link_href && element.link_href.length > 0) {
      const newWindow = window.open(normalizeHref(element.link_href), '_blank');

      // window.open could have failed because of popup blockers, etc.
      if (newWindow) {
        newWindow.focus();
      }
    }
  }

  static isEnabled({ element }: ToolArgs): boolean {
    return Boolean(
      element &&
        isLinkElement(element) &&
        element.link_href &&
        element.link_href.length > 0 &&
        element.link_href !== '#'
    );
  }

  static tooltipPlacement(): Placement {
    return 'bottom';
  }
}

export default ToolOpenLink;
